import { Suspense, useEffect } from 'react'
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from 'react-toastify';

import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import {
  LayoutProvider,
  LayoutSplashScreen
} from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'
import { AuthInit } from './modules/auth'

const App = ({ store, persistor }) => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const handler = (e: MessageEvent) => {
      try {
        const msg = typeof e.data === 'string' ? JSON.parse(e.data) : e.data
        if (msg?.type === 'app-navigate' && msg.path) {
          navigate(msg.path)
        } else if (msg?.type === 'app-open-login') {
          navigate(location.pathname + location.search, { state: { login: location } })
        } else if (msg?.type === "app-open-profile") {
          navigate({}, { state: { profile: location } });
        }
      } catch {}
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [navigate, location])

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        <Suspense fallback={<LayoutSplashScreen />}>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Outlet />
                <MasterInit />
                <ToastContainer />
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </Suspense>
      </PersistGate>
    </Provider>
  )
}

export {App}
